import { ComplaintDTO } from '../../../../Domain/DTO/ComplaintDTO';
import { EComplaintState } from '../../../../Domain/Enum/EComplaintState';
import { CloseAction } from '../Action/CloseAction';
import { MarkAsSatisfiedAction } from '../Action/MarkAsSatisfiedAction';
import { ProposeSolutionAction } from '../Action/ProposeSolutionAction';
import { ComplaintStatusDefault } from './ComplaintStatusDefault';
import { TakenIntoExamination } from './TakenIntoExamination';
import { CancelAction } from '../Action/CancelAction';

export class Processed extends ComplaintStatusDefault{

    public TitleCurrent : string = "complaint:StatusProcessedCurrent";
    public TitleFinished: string = "complaint:StatusProcessedFinished";
    public TitleFuture  : string = "complaint:StatusProcessedFuture";

    public GetActions(dto: ComplaintDTO){
        return [new ProposeSolutionAction(), new MarkAsSatisfiedAction(), new CancelAction()];
    }

    constructor(){
        super();
        this._prevState = new TakenIntoExamination();
        this._currentStatus = EComplaintState.Processed;
    }
}